import React from "react";
import { Avatar, AvatarSize } from "../../commons/Avatar.js";
import { Attachment } from "../attachments/helpers.js";
import { OrganisationAvatarFragment } from "./OrganisationAvatar.generated.js";
import { SxProps } from "@mui/material/styles";

interface Props {
  organisationAvatar: OrganisationAvatarFragment;
  size?: AvatarSize;
  circle?: boolean;
  style?: React.CSSProperties;
  onAttachment?: (attachment: Attachment | null) => Promise<void>;
  disabled?: boolean;
  cameraButtonSx?: SxProps;
  uploadModalProps?: {
    title: string;
    initialTitle: string;
  };
}

export const OrganisationAvatar = ({
  organisationAvatar,
  size = "m",
  circle = false,
  style,
  onAttachment,
  disabled,
  cameraButtonSx,
  uploadModalProps,
}: Props) => {
  return (
    <Avatar
      url={organisationAvatar.logo?.url}
      initials={organisationAvatar.title.substring(0, 2)}
      onAttachment={onAttachment}
      disabled={disabled}
      size={size}
      type={circle ? "circle" : "square"}
      style={style}
      cameraButtonSx={cameraButtonSx}
      uploadModalProps={uploadModalProps}
    />
  );
};
